import { defineComponent as _defineComponent } from 'vue'
import VideoPlayer from '@/components/VideoPlayer.vue'
  import useVideo from '@/composables/useVideo'
  import useIcons from '@/composables/useIcons'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BrowserExtensionModal',
  props: {
    courseId: String,
    lessonId: String,
    moduleId: String,
  },
  setup(__props) {

  

  const videoUrl = 'https://stream.mux.com/u6w1oO94jk6KMRgdNj00U7IWkZUdAWc87dlHz1axZ5008.m3u8'
  const { getPosterImage } = useVideo()
  const { chrome, edge } = useIcons()

  const openChromeWebStore = () => {
    window.open('https://chrome.google.com/webstore/category/extensions', '_blank')
  }

  const openEdgeWebStore = () => {
    window.open('https://microsoftedge.microsoft.com/addons/Microsoft-Edge-Extensions-Home', '_blank')
  }

return { __sfc: true,videoUrl, getPosterImage, chrome, edge, openChromeWebStore, openEdgeWebStore, VideoPlayer, useVideo, useIcons, KetchUpButton }
}

})